import { ensureWapListingDetailVersion, isListingDetailVersionRoute } from '@/utils/wap-listing-detail-version'

export default defineNuxtPlugin(async () => {
  const readiness = ensureWapListingDetailVersion()
  if (isListingDetailVersionRoute(useRoute().path)) {
    await readiness
  } else {
    // Fetch at the same startup time, but do not hold unrelated page hydration.
    readiness.catch(() => console.warn('Unable to initialize detail version'))
  }
})
